<section
  class="guided-tour-step"
  role="dialog"
  aria-modal="true"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  [attr.aria-labelledby]="headingId"
  [attr.aria-describedby]="textId"
  (keydown.escape)="onEscape($event)"
>
  <div class="guided-tour-step__content" aria-live="polite" aria-atomic="true">
    <p class="guided-tour-step__progress">
      {{ 'GUIDED_TOUR.PROGRESS' | translate: { current: stepNumber(), total: stepCount() } }}
    </p>
    <h3 class="guided-tour-step__title" [id]="headingId">{{ step().title | translate }}</h3>
    <p class="guided-tour-step__text" [id]="textId">{{ step().text | translate }}</p>
  </div>
  <div class="guided-tour-step__actions">
    @if (!isLastStep()) {
      <button type="button" class="guided-tour-step__skip" (click)="skip.emit()">
        {{ 'GUIDED_TOUR.SKIP' | translate }}
      </button>
    }
    <button
      type="button"
      class="guided-tour-step__next"
      cdkFocusInitial
      (click)="isLastStep() ? done.emit() : next.emit()"
    >
      {{ (isLastStep() ? 'GUIDED_TOUR.DONE' : 'GUIDED_TOUR.NEXT') | translate }}
    </button>
  </div>
</section>
